import pdfMake from 'pdfmake/build/pdfmake';
import { pontuaCpfCnpj } from '~/utils/functions';
import { ILoja, periodoProps, rowsProps } from '../types';

export default class PDFGenerator {
  private docDefinition: any;

  constructor(
    private rows: rowsProps[],
    private infoLoja: ILoja,
    private periodo: periodoProps,
  ) {
    this.docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [30, 85, 30, 40],
      defaultStyle: {
        fontSize: 9.5,
      },
      header: this.createHeader(),
      content: this.createContent(),
    };
  }

  private createHeader() {
    return (currentPage: number) => {
      const formatPageNumber = (page: number) => {
        return page.toString().padStart(4, '0');
      };

      const { infoLoja, periodo } = this;
      return [
        {
          layout: 'noBorders',
          table: {
            widths: ['100%'],
            headerRows: 3,
            body: [
              [
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['50%', '50%'],
                    body: [
                      [
                        {
                          text: `${infoLoja.des_loja}`,
                          alignment: 'left',
                          bold: true,
                          margin: [0, 0, 0, 0],
                        },
                        {
                          text: `Relatório Fluxo de Caixa - Período:(${periodo.dta_inicio} - ${periodo.dta_final})`,
                          alignment: 'right',
                          fontSize: 9,
                          margin: [0, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              [
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['85%', '15%'],
                    body: [
                      [
                        {
                          text: `${infoLoja.des_logradouro} - Nº: ${infoLoja.num_endereco} - ${infoLoja.des_bairro} CEP ${infoLoja.num_cep} ${infoLoja.des_cidade} - ${infoLoja.des_uf}`,
                          alignment: 'left',
                          bold: true,
                          margin: [0, -7.5, 0, 0],
                        },
                        {
                          text: `Folha Nº: ${formatPageNumber(currentPage)}`,
                          alignment: 'right',
                          margin: [0, -7.5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              [
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['100%'],
                    body: [
                      [
                        {
                          text: `CNPJ: ${pontuaCpfCnpj(infoLoja.num_cnpj)}`,
                          alignment: 'left',
                          bold: true,
                          margin: [0, -7.5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
            ],
          },
          margin: [30, 30, 30, 15],
        },
        PDFGenerator.createDividerHeader(),
      ];
    };
  }

  private static createDividerHeader() {
    return {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 535,
          y2: 0,
          lineWidth: 1,
          lineColor: '#000000',
        },
      ],
      margin: [30, -13, 30, 0],
    };
  }

  private createContent() {
    const { rows } = this;

    const tableBody = [
      [
        { text: 'Dia', style: 'tableHeader', bold: true, alignment: 'center' },
        {
          text: 'Recebimentos',
          style: 'tableHeader',
          bold: true,
          alignment: 'center',
        },
        {
          text: 'Pagamentos',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
        {
          text: 'Consolidado',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
        {
          text: 'Saldo',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
      ],
      ...rows.map((item: rowsProps) => [
        {
          text: `${item.dta_diario},  (${item.dia_semana})`,
          alignment: 'left',
        },
        { text: item.val_total_receber, alignment: 'right' },
        { text: item.val_total_pagar, alignment: 'right' },
        { text: item.val_total_consolidado, alignment: 'right' },
        { text: item.val_saldo, alignment: 'right' },
      ]),
    ];
    return {
      table: {
        widths: ['25%', '19.5%', '18.5%', '19.5%', '17.5%'],
        headerRows: 1,
        body: tableBody,
      },
    };
  }

  public generatePDF(): void {
    try {
      const pdfDocGenerator = pdfMake.createPdf(this.docDefinition);

      pdfDocGenerator.open();
    } catch (error) {
      console.log('Erro ao gerar o PDF:', error);
    }
  }
}
